module.exports = __webpack_public_path__ + "/content/skins/rivian/fonts/NotoSans-SemiBold.ttf";